import { environment } from '@env/environment';
import { Component, OnInit } from '@angular/core';
import { ModalService } from '@app/services/modal/modal.service';

@Component({
    selector: 'nh-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  gatewayURL = environment.gatewayURL;
  currentLang: string;
  globalLang: string;

  constructor(private modal: ModalService) {
  }

  ngOnInit(): void {
    this.currentLang = sessionStorage.getItem('currentLang');
    this.globalLang = sessionStorage.getItem('globalTranslatedLan');
  }

  get phoneNumber(): string {
    const appType = sessionStorage.getItem('appType');
    const currentGlobalLang = sessionStorage.getItem('globalTranslatedLan');
    // updating phone number in footer when user is filing medical appeal
    if (appType === 'MEDICAL_APPEAL') {
      if (currentGlobalLang === 'ar' || currentGlobalLang === 'fa') {
        return '3192-878-800';
      } else {
        return '800-878-3192'
      }
    } else {
      if (currentGlobalLang === 'ar' || currentGlobalLang === 'fa') {
        return '0701-259-855';
      } else {
        return '855-259-0701';
      }
    }
  }

  openAnalyticsPolicy() {
    return this.modal.openAnalyticsPolicy();
  }

  decreaseFont(){
    return this.globalLang === 'vi' || this.globalLang === 'ja' || this.globalLang === 'tl' || this.globalLang === 'de' || this.globalLang === 'ru' || this.globalLang === 'fr';
  }
}
